import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { NewAuthService } from 'src/app/services/auth/new-auth-service.service';

@Component({
  selector: 'app-clinical-time-alert',
  templateUrl: './clinical-time-alert.component.html',
  styleUrls: ['./clinical-time-alert.component.scss'],
})
export class ClinicalTimeAlertComponent implements OnInit {
  user: User;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private auth: NewAuthService,
    private dialogRef: MatDialogRef<ClinicalTimeAlertComponent>
  ) {}

  ngOnInit(): void {
    this.user = this.auth.user;
  }

  roundTime(time: number): string {
    let mins = Math.floor(time);
    let secs = ((time - mins) * 60).toFixed(0);
    if (Number(secs) === 60) {
      mins += 1;
      secs = '00';
    }
    return `${mins} mins ${secs} secs`;
  }

  close(): void {
    this.dialogRef.close();
  }

  disenroll(): void {
    this.dialogRef.close({
      disenroll: true,
    });
  }

  sendAlert(): void {
    this.dialogRef.close(true);
  }
}
